export default __webpack_public_path__ + "media/images/logotop-3dd77a5bb842f35bdac5052a52126fbf.png";